import { Content, Header, Root, Item, Trigger } from '@radix-ui/react-accordion'
import type { ReactNode } from 'react'
import { ChevronDownIcon } from '@icons'

import WebsiteSeo from '../../seo'

import styles from './styles.module.scss'

type WebsiteAccordionProps = {
  headerText: string
  children: ReactNode
}

type WebsiteFAQProps = {
  title: string
  content: WebsiteAccordionProps[]
}

const SEO = {
  title: 'FAQ // Olby',
  description:
    'Whether you have questions about hiring Olby or about applying for jobs, we have the answers for both.',
}

export const WebsiteAccordionFAQ = ({ title, content }: WebsiteFAQProps) => {
  return (
    <>
      <WebsiteSeo seo={SEO} />
      <h2 className={styles['accordion-faq-title']}>{title}</h2>
      {content.map(item => (
        <Root
          key={item.headerText}
          type="single"
          collapsible
          className={styles['accordion-container']}
        >
          <Item value="item">
            <Header>
              <Trigger className={styles['trigger']}>
                <p className={styles['trigger-label']}>
                  {item.headerText}
                  <ChevronDownIcon className={styles['trigger-icon']} />
                </p>
              </Trigger>
            </Header>
            <Content className={styles['content']}>
              <div className={styles['content-wrapper']}>{item.children}</div>
            </Content>
          </Item>
        </Root>
      ))}
    </>
  )
}

export default WebsiteAccordionFAQ
